import LimitField from "./LimitField.jsx"

export default function SegmentForm({ options, config, setConfig }) {
  const segments = options?.segments ?? []
  const value = config.segment_id ?? ""

  return (
    <div className="space-y-3">
      <label className="block">
        <span className="text-xs font-medium text-muted-foreground">Segment</span>
        <select value={value}
                onChange={e => setConfig({ ...config, segment_id: Number(e.target.value) || null })}
                className="mt-1 w-full h-9 px-2 rounded-md border border-border bg-background text-sm">
          <option value="">Pick a segment…</option>
          {segments.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
        {segments.length === 0 && (
          <p className="text-[11px] text-muted-foreground mt-1">
            No segments in this project yet. Create one under <strong>Segments</strong>.
          </p>
        )}
      </label>

      <LimitField config={config} setConfig={setConfig} />
    </div>
  )
}
